import PropTypes from 'prop-types';

const rankingType = PropTypes.exact({
  agility: PropTypes.number,
  coldRisk: PropTypes.number.isRequired,
  composure: PropTypes.number.isRequired,
  conscientiousness: PropTypes.number.isRequired,
  hotRisk: PropTypes.number.isRequired,
  inquisitiveness: PropTypes.number.isRequired,
  interpersonalSkills: PropTypes.number,
  mentalHorsepower: PropTypes.number.isRequired,
  observation: PropTypes.number,
  sociability: PropTypes.number.isRequired,
});

const additionalRankingType = PropTypes.exact({
  agility: PropTypes.number,
  interpersonalSkills: PropTypes.number,
  observation: PropTypes.number,
});

export { additionalRankingType };
export default rankingType;
